import React from 'react';
import DiffMatchPatch from "diff-match-patch";
import PropTypes from "prop-types";
import AuditInput from "./AuditInput";

const renderDiffDMP = (before = "", after = "", cleanUpMode = 'semantic', editCost = 4) => {
    const dmp = new DiffMatchPatch();

    const diff = dmp.diff_main(before, after);
    if (cleanUpMode === "semantic")
        dmp.diff_cleanupSemantic(diff);

    if (cleanUpMode === "efficiency") {
        dmp.Diff_EditCost = editCost;
        dmp.diff_cleanupEfficiency(diff);
    }

    const mappedNodes = diff.map(group => {
        const key = group[0];
        let value = group[1];
        let nodeClassName;

        // preprocess newly added/removed newline characters
        // (only newline, ignore full paragraph change) into pilcrow (¶)
        if ((key === -1 || key === 1) && !/\S/.test(value)) {
            const linebreaks = value.match(/(\r\n|\r|\n)/g);
            if (linebreaks) {
                if (key === -1)
                    value = `\u00b6`.repeat(linebreaks.length);
                if (key === 1)
                    value = `\u00b6\n`.repeat(linebreaks.length);
            }
        }

        if (key === 1)
            nodeClassName = "row-added";
        if (key === -1)
            nodeClassName = "row-removed--red";
        return <span key={key} className={nodeClassName}>{value}</span>;
    });

    return <span style={{ whiteSpace: "pre-wrap" }}>{mappedNodes}</span>;
};

function AuditInputDiffDMP(
    { before = "", after = "", cleanUpMode = 'semantic', editCost = 4, ...restProps },
) {
    return (
        <AuditInput
            customRenderInput={
                {
                    renderEditDiv: () => renderDiffDMP(before, after, cleanUpMode, editCost),
                }
            }
            before={before}
            after={after}
            {...restProps}
        />
    );
}

AuditInputDiffDMP.propTypes = {
    before: PropTypes.string,
    after: PropTypes.string,
    cleanUpMode: PropTypes.oneOf(["efficiency", "semantic"]),
};

export default AuditInputDiffDMP;
